"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _reactNativeWeb = require("react-native-web");

var _AaButton = require("./AaButton.model");

var _AaButtonInner = _interopRequireDefault(require("./AaButtonInner.component"));

var _StyleSheet = _interopRequireDefault(require("../../PlatformStyleSheet/StyleSheet"));

var AaButton = function AaButton(props) {
  var controls = props.controls || null;
  var config = controls && controls.config || {};

  var onButtonPress = function onButtonPress(href) {
    if (href) {
      return window.location = href;
    }

    if (config.onPress) {
      return config.onPress;
    }

    if (!controls) {
      return;
    }

    controls.onButtonPress(true);
  };

  var pressHandler = function pressHandler(event) {
    // prevents propagation to overlapped buttons
    event.preventDefault();
    onButtonPress(config.href);
  };

  return /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: defaultStyles.touchableContainer
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.TouchableOpacity, (0, _extends2["default"])({
    accessible: controls.accessible !== null ? controls.accessible : true,
    accessibilityRole: "button",
    nativeID: controls.id,
    style: [defaultStyles.buttonContainer, controls && controls.customStyle && controls.customStyle.container, controls.disabled && [defaultStyles.buttonContainerDisabled, controls.buttonDisabledColor], controls && controls.customStyle && controls.customStyle.buttonContainer],
    onPress: pressHandler,
    disabled: controls.disabled
  }, controls.otherTouchableOpacityProps), /*#__PURE__*/_react["default"].createElement(_AaButtonInner["default"], props)));
};

var defaultStyles = _StyleSheet["default"].create({
  touchableContainer: {
    flex: 1,
    justifyContent: 'center',
    web: {
      height: 56,
      width: '100%'
    }
  },
  buttonContainer: {
    alignItems: 'center',
    backgroundColor: '#DC3224',
    borderRadius: 4,
    paddingVertical: 19
  },
  buttonContainerDisabled: {
    web: {
      cursor: 'not-allowed'
    },
    backgroundColor: '#ababab',
    borderColor: '#ababab'
  }
});

var _default = AaButton;
exports["default"] = _default;